import React from 'react';
import PropTypes from 'prop-types';
import { FaPaperPlane } from 'react-icons/fa';
import { formatBoardUserInitials } from '../board/boardDisplayUtils';
import { YInput } from '../../../ui/YInput';

export function ClubBoardReplyComposer({
  currentUser,
  value,
  onChange,
  onSubmit,
  onKeyDown,
  disabled = false,
  saving = false,
  placeholder = 'Write a reply…',
}) {
  const initials = formatBoardUserInitials(currentUser);

  return (
    <div className="club-board-post__reply-form">
      <span className="club-board-post__reply-avatar club-board-post__reply-avatar--self" aria-hidden="true">
        {initials}
      </span>
      <div className="club-board-post__reply-input-wrap">
        <YInput
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          disabled={disabled || saving}
          className="club-board-post__reply-input"
          aria-label={placeholder}
        />
        <button
          type="button"
          className="club-board-post__reply-send"
          disabled={disabled || saving || !value.trim()}
          onClick={onSubmit}
          aria-label="Send reply"
        >
          <FaPaperPlane aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}

ClubBoardReplyComposer.propTypes = {
  currentUser: PropTypes.object,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  disabled: PropTypes.bool,
  saving: PropTypes.bool,
  placeholder: PropTypes.string,
};
